import { Radio } from "antd"
import { useEffect, useState } from "react";
import { getTranslated } from "../../utils/CommonUtils";
import { useSelector } from "react-redux";

/** Custom Toggle Button using Antd Radio Button 
 * @param {*} props 
 * @param {String} props.value Default/selected value of the button
 * @param {Array[Object]} props.options  array of objects as label-value pair
   @example props.options => [{
        label: Private network,
        value: private_nw
        }, 
        ...
    ]
 * @param {function} props.handleChange to handle the radio button selection
 * @returns {React.ReactNode} returns a reactNode to display a radio button group
*/

const ToggleButton = (props) => {

    const [value, setValue] = useState()
    const [options, setOptions] = useState([])

    const dict = useSelector((state) => state.common.dict)

    useEffect(() => {
        const val = props.value !== undefined ? props.value : props.options[0]?.value
        setValue(val)

        const tempOptions = props.options.map(option => {
            return {
                ...option,
                label: getTranslated(dict, option.label)
            }
        })
        setOptions(tempOptions)
    }, [props.value, props.options, dict])

    const onChange = ({ target: { value } }) => {
        props.handleChange && props.handleChange(value)
        setValue(value);
    };

    return <div className={`cust-toggle-btn ${props.className}`}>
        <Radio.Group
            options={options}
            onChange={onChange}
            value={value}
            optionType="button"
            buttonStyle="solid"
        />
    </div>
}

export default ToggleButton